import React, { useState } from "react"
import { Button, Image } from "semantic-ui-react"
import * as Sentry from "@sentry/react"
import BlackWalletImage from "../../../images/dashboard/black-wallet.svg"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

const InviteFriends = ({ user, t }) => {
  const [isCodeCopied, setIsCodeCopied] = useState(false)
  const [copyError, setCopyError] = useState(null)

  const copyInviteLinkToClickboard = async () => {
    try {
      await navigator.clipboard.writeText(
        `${process.env.REACT_APP_ROOT_URL}/#/invite/${user.referral_code}`
      )
      setIsCodeCopied(true)
    } catch (error) {
      Sentry.captureException(error)
      setCopyError(error)
    }
  }
  return (
    <div className="dashboard-invite-friends-card">
      <div className="dashboard-invite-friends-card-content">
        <p className="invite-friends-card-heading">{t("earnMoneyTowardsFreeMaintenanceMsg")}</p>
        <p className="invite-friends-card-text">{t("giveAFriend$10Msg")}</p>
        <p className="referralCodeCopyText">{isCodeCopied ? t("copiedText") : ""}</p>
        <Button onClick={copyInviteLinkToClickboard} className="invite-friends-card-button">
          {t("copyCodeLbl")} {user.referral_code}
        </Button>
      </div>
      <Image className="invite-friends-black-wallet-image" src={BlackWalletImage} />
    </div>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(withTranslation("justForYouCards")(InviteFriends))
